import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const empresaGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const role = authService.getCurrentUserRole();
  if (role === 'Empresa') {
    return true;
  }

  // Admin (u otro rol) no debe ver las pantallas operativas.
  router.navigate(['/users']);
  return false;
};